import {
  CartesianGrid,
  ComposedChart,
  Legend,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

/**
 * One usecase's compliance over time — the KPI against its target, and the cumulative per cent.
 *
 * This is the chart the Deep-Dive has always drawn. It lives here so the Dashboard popup and the
 * Compliance Data screen draw exactly the same picture from exactly the same series.
 */
export const ComplianceTrendChart = ({ series = [], height = 260, testId }) => (
  <div className="w-full min-w-[280px]" style={{ height }} data-testid={testId}>
    <ResponsiveContainer width="100%" height={height} minWidth={280} debounce={40}>
      <ComposedChart data={series} margin={{ top: 8, right: 8, left: -18, bottom: 0 }}>
        <CartesianGrid stroke="hsl(var(--border))" vertical={false} />
        <XAxis
          dataKey="date"
          tick={{ fontSize: 10, fontFamily: "IBM Plex Mono" }}
          tickFormatter={(d) => String(d).slice(5)}
          stroke="hsl(var(--muted-foreground))"
        />
        <YAxis
          yAxisId="left"
          tick={{ fontSize: 10, fontFamily: "IBM Plex Mono" }}
          stroke="hsl(var(--muted-foreground))"
        />
        <YAxis
          yAxisId="right"
          orientation="right"
          domain={[0, 120]}
          tickFormatter={(v) => `${v}%`}
          tick={{ fontSize: 10, fontFamily: "IBM Plex Mono" }}
          stroke="hsl(199 89% 48%)"
        />
        <Tooltip
          contentStyle={{
            background: "hsl(var(--popover))",
            border: "1px solid hsl(var(--border))",
            borderRadius: 0,
            fontSize: 12,
          }}
        />
        <Legend wrapperStyle={{ fontSize: 11 }} />
        <Line
          yAxisId="left"
          type="stepAfter"
          dataKey="baseline"
          name="Baseline KPI"
          stroke="hsl(var(--at-risk))"
          strokeDasharray="2 3"
          strokeWidth={1.5}
          dot={false}
        />
        <Line
          yAxisId="left"
          type="stepAfter"
          dataKey="target"
          name="Target KPI"
          stroke="hsl(var(--muted-foreground))"
          strokeDasharray="5 4"
          strokeWidth={1.5}
          dot={false}
        />
        <Line
          yAxisId="left"
          type="monotone"
          dataKey="actual"
          name="Actual KPI"
          stroke="hsl(var(--primary))"
          strokeWidth={2}
          dot={{ r: 2 }}
        />
        <Line
          yAxisId="right"
          type="monotone"
          dataKey="pct"
          name="Compliance % that day"
          stroke="hsl(var(--watch))"
          strokeWidth={1.5}
          dot={false}
        />
        <Line
          yAxisId="right"
          type="monotone"
          dataKey="cumulative"
          name="Cumulative compliance %"
          stroke="hsl(199 89% 48%)"
          strokeWidth={2}
          dot={false}
        />
      </ComposedChart>
    </ResponsiveContainer>
  </div>
);
